// 第三方平台常量

export const platformName = {
  google: 'Google',
  facebook: 'Facebook',
}
